// LA MATRIZ DE HABILIDADES, EN COLORES Y EN PALABRAS · Fase 4.
//
// El estado lo calcula el servidor contra la fecha de hoy y llega en la
// respuesta. Aquí solo se traduce: recalcularlo en el navegador daría
// dos versiones de la misma verdad, y la del navegador depende del reloj
// de un teléfono que puede estar mal.
import { ESTADO_POR_DEFECTO } from './estados';

export const ESTADO_HABILIDAD = {
  VIGENTE: { etiqueta: 'Vigente', color: 'verde' },
  // «No caduca» NO es verde a secas: es un hecho distinto, y pintarlo
  // igual escondería cuáles hay que renovar y cuáles no.
  SIN_VENCIMIENTO: { etiqueta: 'No caduca', color: 'azul' },
  POR_VENCER: { etiqueta: 'Por vencer', color: 'ambar' },
  VENCIDA: { etiqueta: 'Vencida', color: 'rojo' },
};

export function estadoHabilidad(clave) {
  return ESTADO_HABILIDAD[clave] || ESTADO_POR_DEFECTO;
}

export const NIVELES = {
  EN_ENTRENAMIENTO: 'En entrenamiento',
  AUTORIZADO: 'Autorizado',
  INSTRUCTOR: 'Instructor',
};

/** Qué pasa hoy con esta operación, en una frase. */
export function comoVaLaOperacion(op) {
  if (!op) return '';
  if (op.sin_exigencias) {
    return 'No se le exige ninguna habilidad. Si de verdad hace falta '
      + 'alguna, agrégala: mientras no la tenga, TEGO no puede avisarte '
      + 'de nada sobre este trabajo.';
  }
  if (op.cubierta) return 'Hay alguien autorizado hoy para todo lo que exige.';
  return `Hoy nadie está autorizado para: ${op.faltan.join(', ')}. `
    + 'Renueva la vigencia de quien siga capacitado, o forma a alguien.';
}

// EL AVISO DE LA CONSTANCIA SIN VERIFICAR.
//
// Vive aquí para poder probarlo: es la frase que impide que alguien
// entregue como oficial un formato que nadie comparó contra el vigente
// de la Secretaría del Trabajo.
export const AVISO_DC3_SIN_VERIFICAR =
  'Este formato todavía no se ha comparado contra el DC-3 vigente de la '
  + 'Secretaría del Trabajo. Sirve para tu archivo interno; no lo '
  + 'entregues a un trabajador ni a una inspección hasta que quien '
  + 'administra TEGO lo verifique.';
